// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"15eb86c4","83":"5c65ed94","229":"698808d8","392":"88e8f408","439":"7a42d56e","486":"adbe2d48","568":"88615cab","675":"f83928d1","713":"abdc4735","728":"8fb461fa","922":"e53957fc","929":"b4327789"}[chunkId] + ".chunk.js";
};